"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var object_fit_images_1 = __importDefault(require("object-fit-images"));
var classNameHovered = 'hovered';
var classImg = 'img-object-fit';
var maxVisibleImg = 5;
var CarsItemImgsPreview = function (_a) {
    var _b = _a.imgs, imgs = _b === void 0 ? [] : _b;
    var _c = react_1.useState(''), className = _c[0], setClassName = _c[1];
    var countImgs = imgs.length;
    var visibleImgs = imgs.slice(0, maxVisibleImg);
    var countMoreImgs = countImgs - maxVisibleImg;
    var handleMouseEnter = react_1.useCallback(function () {
        setClassName(classNameHovered);
    }, []);
    var handleMouseLeave = react_1.useCallback(function () {
        setClassName('');
    }, []);
    var renderPreview = function () {
        return visibleImgs.map(function (img, idx) { return (react_1.default.createElement("div", { className: "azgazui__cars-item-img-thumb" },
            react_1.default.createElement("img", { className: classImg, src: img.url, alt: img.alt }),
            react_1.default.createElement("div", { className: "azgazui__cars-item-img-thumb_item" }),
            countMoreImgs > 0 && idx === visibleImgs.length - 1 ? (react_1.default.createElement("div", { className: "azgazui__cars-item-img_count-more" },
                react_1.default.createElement("span", null,
                    "\u0415\u0449\u0435 ",
                    countMoreImgs,
                    " \u0444\u043E\u0442\u043E"))) : null)); });
    };
    react_1.useEffect(function () {
        // полифилл для object-fit style
        object_fit_images_1.default("." + classImg);
    }, []);
    return (react_1.default.createElement("div", { className: "azgazui__cars-item-img" },
        react_1.default.createElement("div", { className: classnames_1.default(className, 'azgazui__cars-item-img-thumb_wrap', {
                'azgazui__cars-item-img_single': countImgs === 1,
            }), onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, renderPreview())));
};
CarsItemImgsPreview.displayName = 'CarsItemImgsPreview';
exports.default = CarsItemImgsPreview;
